<template>
  <div class="erp-integration">
    <card :title="$t('tools.erp_integration.title')" id="erp-integration">
      <div class="options-grid">
        <router-link to="/tools/erp-integration/configuration" class="option-card">
          <div class="option-icon-holder">
            <img src="~@/assets/images/desktop/icons/controls/cog.svg" class="option-icon" />
          </div>
          <div class="option-title">{{ $t("tools.erp_integration.erp_configuration") }}</div>
          <div class="option-description">{{ $t("tools.erp_integration.erp_configuration_description") }}</div>
        </router-link>

        <router-link to="/tools/erp-integration/nomenclatures" class="option-card">
          <div class="option-icon-holder">
            <img src="~@/assets/images/desktop/icons/controls/warehouse.svg" class="option-icon" />
          </div>
          <div class="option-title">{{ $t("tools.erp_integration.nomenclatures") }}</div>
          <div class="option-description">{{ $t("tools.erp_integration.nomenclatures_description") }}</div>
        </router-link>

        <router-link to="/tools/erp-integration/recepcio" class="option-card">
          <div class="option-icon-holder">
            <img src="~@/assets/images/desktop/icons/controls/warehouse.svg" class="option-icon" />
          </div>
          <div class="option-title">{{ $t("tools.erp_integration.recepcio") }}</div>
          <div class="option-description">{{ $t("tools.erp_integration.recepcio_description") }}</div>
        </router-link>

        <router-link to="/tools/erp-integration/transfer" class="option-card">
          <div class="option-icon-holder">
            <img src="~@/assets/images/desktop/icons/controls/warehouse.svg" class="option-icon" />
          </div>
          <div class="option-title">{{ $t("tools.erp_integration.transfer") }}</div>
          <div class="option-description">{{ $t("tools.erp_integration.transfer_description") }}</div>
        </router-link>

        <router-link to="/tools/erp-integration/consum" class="option-card">
          <div class="option-icon-holder">
            <img src="~@/assets/images/desktop/icons/controls/warehouse.svg" class="option-icon" />
          </div>
          <div class="option-title">{{ $t("tools.erp_integration.consum") }}</div>
          <div class="option-description">{{ $t("tools.erp_integration.consum_description") }}</div>
        </router-link>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: "ErpIntegration",
};
</script>

<style scoped>
.options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}

.option-card {
  display: block;
  min-height: 110px;
  border: 1px solid #dfe6ef;
  border-radius: 12px;
  padding: 16px;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  text-decoration: none;
}

.option-card:hover,
.option-card:focus {
  border-color: #9ab8de;
  box-shadow: 0 6px 18px rgba(21, 68, 126, 0.08);
  outline: none;
}

.option-title {
  color: #183052;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 6px;
}

.option-icon-holder {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #f2f7fd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.option-icon {
  width: 18px;
  height: 18px;
}

.option-description {
  color: #5f6b7a;
  font-size: 13px;
  line-height: 1.45;
}
</style>
